import styled from 'styled-components';
import HappyPreviousSvg from './happyPrevious.svg';

const HappyPreviousIcon = styled(HappyPreviousSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '1.5rem'};
  height: ${props => props.height || '1.5rem'};
  margin: ${props => props.margin};
  fill: ${props =>
    props.isactive === 'true'
      ? props.theme.colors.goBrandBlue.base
      : props.theme.colors.goBrandBlue.medium};
`;

export default HappyPreviousIcon;
